// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

const url = URL;
const urlSearchParams = URLSearchParams;

export { url as URL, urlSearchParams as URLSearchParams };
